import { Grid, Popper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectFinancialDisclosure } from '~/store/legacy/selector/shoppingCartSelectors';

const useStyles = makeStyles((theme) => ({
  paper: {
    border: '1px solid',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    justifyContent: 'center',
    textAlign: 'center',
  },
  popper: {
    maxWidth: '400px',
  },

  text: {
    fontSize: 12,
    color: '#9B9B9B',
  },
}));

const RestaurantServices = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [message, setMessage] = React.useState(
    'The restaurants in your order are charged a varying amount of commission up to 15% of subtotal'
  );

  const financialDisclosure = useSelector(selectFinancialDisclosure);

  useEffect(() => {
    if (financialDisclosure) {
      const attributes = financialDisclosure.attributes;
      if (attributes && attributes.name && attributes.value) {
        setMessage(`${attributes.name} ${attributes.value}`);
      }
    }
  }, [financialDisclosure]);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div style={props.style} aria-label='Restaurant Services information'>
      <Typography
        type='button'
        className={classes.text}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}>
        Restaurant Services
      </Typography>
      <Popper id={id} open={open} anchorEl={anchorEl} className={classes.popper}>
        <Grid className={classes.paper} container>
          <Typography variant='h6'>Chowbus Commissions and Fees to the Restaurant</Typography>
          {message}
          <Typography className={classes.text}>
            * Restaurants pay Platform Fees when they opt-in to subsidize Free Delivery for all
            Customers
          </Typography>
          <a href='https://chowbus.squarespace.com/commission_disclosure'>Learn More</a>
        </Grid>
      </Popper>
    </div>
  );
};

export default RestaurantServices;
